





























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { UserModule } from '@/store/modules/user'
import { getBoUrl } from '@/api/http-constants'
import { getOperationID } from '@/api/operations'
import { NotificationsModule } from '@/store/modules/notifications'

@Component({
    components: { SmoothReflow },
})
export default class Lock extends Vue {
    apiService = new ApiService()

    userId: number = null

    // --- Financement ---
    userHasFile: boolean = false
    userFileStatus: string = null
    uploadError: string = null
    uploadSuccess: string = null
    uploading: boolean = false
    file: File = null

    // --- Identité ---
    userHasIdentity: boolean = false
    identityFileStatus: string = null
    identityUploadError: string = null
    identityUploadSuccess: string = null
    identityUploading: boolean = false
    identityFile: File = null

    // --- Lettre d'intention d'achat ---
    userHasPurchaseLetter: boolean = false
    purchaseLetterStatus: string = null
    purchaseLetterUploadError: string = null
    purchaseLetterUploadSuccess: string = null
    purchaseLetterUploading: boolean = false
    purchaseLetterFile: File = null
    purchaseLetterModelUrl: string = null
    brsModelUrl: string = null

    // --- BRS ---
    userHasBrs: boolean = false
    brsFileStatus: string = null
    brsUploadError: string = null
    brsUploadSuccess: string = null
    brsUploading: boolean = false
    brsFiles: File[] = []
    isBrsEligible: boolean = false

    userOperationId: number = null
    operationName: string = null

    DOC_STATUSES: object = {
        pending: 'En cours de vérification',
        refused: 'Refusé',
        validated: 'Validé',
    }

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.userId = UserModule.userInfos.id

        const [buyerResp, opeId] = await Promise.all([
            this.apiService.getBuyer(this.userId),
            getOperationID(),
        ])

        const data = buyerResp.data

        // Financement
        this.userHasFile = data.fundingStatus != null
        if (this.userHasFile) {
            this.userFileStatus = this.DOC_STATUSES[data.fundingStatus]
        }

        // Identité
        this.userHasIdentity = data.identityStatus != null
        if (this.userHasIdentity) {
            this.identityFileStatus = this.DOC_STATUSES[data.identityStatus]
        }

        // Lettre d'intention d'achat
        this.userHasPurchaseLetter = data.purchaseLetterStatus != null
        if (this.userHasPurchaseLetter) {
            this.purchaseLetterStatus = this.DOC_STATUSES[data.purchaseLetterStatus]
        }

        // BRS
        this.userHasBrs = data.brsStatus != null
        if (this.userHasBrs) {
            this.brsFileStatus = this.DOC_STATUSES[data.brsStatus]
        }

        // BRS eligibility from user operation
        if (opeId) {
            try {
                const userOpeResp = await this.apiService.getUserOperation(this.userId, opeId)
                this.userOperationId = userOpeResp.data.id
                this.isBrsEligible = !!userOpeResp.data.brs
            } catch (e) {
                this.isBrsEligible = false
            }
        }

        // Modèles de documents liés à l'opération
        if (opeId) {
            try {
                const opeResp = await this.apiService.getOperationDetails(opeId)
                const boUrl = getBoUrl().replace(/\/$/, '')
                if (opeResp.data.purchaseLetterFilePath) {
                    this.purchaseLetterModelUrl = boUrl + opeResp.data.purchaseLetterFilePath
                }
                if (opeResp.data.brsAttestationFilePath) {
                    this.brsModelUrl = boUrl + opeResp.data.brsAttestationFilePath
                }
                this.operationName = opeResp.data.name || null
            } catch (e) {
                // no model available
            }
        }
    }

    get userFullName(): string {
        const u = UserModule.userInfos
        return `${u.firstname} ${u.lastname}`.trim()
    }

    get identityStatusClass() {
        return this.statusClass(this.identityFileStatus)
    }
    get fundingStatusClass() {
        return this.statusClass(this.userFileStatus)
    }
    get purchaseLetterStatusClass() {
        return this.statusClass(this.purchaseLetterStatus)
    }
    get brsStatusClass() {
        return this.statusClass(this.brsFileStatus)
    }

    statusClass(status: string) {
        if (status === this.DOC_STATUSES['validated']) return 'text-success'
        if (status === this.DOC_STATUSES['refused']) return 'text-danger'
        return 'text-muted'
    }

    sendAdminNotification(type: string, message: string, context: object = {}) {
        this.apiService.postAdminNotification({ type, message, context }).catch(() => { /* silent */ })
    }

    // --- Financement ---
    showModal() {
        const modal = $(this.$refs.uploadModal) as any
        modal.modal('show')
    }

    uploadFile() {
        if (this.file == null || this.uploading) return

        $(this.$refs.uploadModalButton).children('i').removeClass('hidden').attr('disabled', 'true')
        this.uploadError = null
        this.uploadSuccess = null
        this.uploading = true

        const fileReader = new FileReader()
        fileReader.readAsDataURL(this.file)
        fileReader.onload = () => {
            const dataURI = fileReader.result as string
            this.apiService.postFunding(this.userId, { funding: dataURI, user_operation_id: this.userOperationId })
                .then(() => {
                    $(this.$refs.uploadModalButton).children('i').addClass('hidden')
                    this.userHasFile = true
                    this.userFileStatus = this.DOC_STATUSES['pending']
                    this.uploading = false
                    this.uploadSuccess = 'Le document a été envoyé avec succès'
                    NotificationsModule.ForceRefreshNotifications()
                    this.sendAdminNotification(
                        'document',
                        `${this.userFullName} a déposé son document de financement.`,
                        { user_id: this.userId, user_operation_id: this.userOperationId }
                    )
                })
                .catch(() => {
                    $(this.$refs.uploadModalButton).children('i').addClass('hidden')
                    this.uploadError = "Le document n'a pas pu être envoyé."
                    this.uploading = false
                })
        }
    }

    // --- Identité ---
    showIdentityModal() {
        const modal = $(this.$refs.identityModal) as any
        modal.modal('show')
    }

    uploadIdentity() {
        if (this.identityFile == null || this.identityUploading) return

        $(this.$refs.identityModalButton).children('i').removeClass('hidden').attr('disabled', 'true')
        this.identityUploadError = null
        this.identityUploadSuccess = null
        this.identityUploading = true

        const fileReader = new FileReader()
        fileReader.readAsDataURL(this.identityFile)
        fileReader.onload = () => {
            const dataURI = fileReader.result as string
            this.apiService.postIdentity(this.userId, { identity: dataURI, user_operation_id: this.userOperationId })
                .then(() => {
                    $(this.$refs.identityModalButton).children('i').addClass('hidden')
                    this.userHasIdentity = true
                    this.identityFileStatus = this.DOC_STATUSES['pending']
                    this.identityUploading = false
                    this.identityUploadSuccess = 'Le document a été envoyé avec succès'
                    NotificationsModule.ForceRefreshNotifications()
                    this.sendAdminNotification(
                        'document',
                        `${this.userFullName} a déposé sa pièce d'identité.`,
                        { user_id: this.userId, user_operation_id: this.userOperationId }
                    )
                })
                .catch(() => {
                    $(this.$refs.identityModalButton).children('i').addClass('hidden')
                    this.identityUploadError = "Le document n'a pas pu être envoyé."
                    this.identityUploading = false
                })
        }
    }

    // --- BRS ---
    showBrsModal() {
        const modal = $(this.$refs.brsModal) as any
        modal.modal('show')
    }

    onBrsFilesChange(event: Event) {
        const input = event.target as HTMLInputElement
        if (input.files) {
            const newFiles = Array.from(input.files)
            newFiles.forEach(f => {
                if (!this.brsFiles.find(existing => existing.name === f.name && existing.size === f.size)) {
                    this.brsFiles.push(f)
                }
            })
            input.value = ''
        }
    }

    removeBrsFile(index: number) {
        this.brsFiles.splice(index, 1)
    }

    uploadBrs() {
        if (!this.brsFiles.length || this.brsUploading) return

        $(this.$refs.brsModalButton).attr('disabled', 'true')
        $(this.$refs.brsModalButton).children('i').removeClass('hidden')
        this.brsUploadError = null
        this.brsUploadSuccess = null
        this.brsUploading = true

        const readFile = (file: File): Promise<string> =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result as string)
                reader.onerror = reject
            })

        Promise.all(
            this.brsFiles.map(f =>
                readFile(f).then(dataURI =>
                    this.apiService.postBrs(this.userId, { brs: dataURI, user_operation_id: this.userOperationId })
                )
            )
        )
            .then(() => {
                $(this.$refs.brsModalButton).children('i').addClass('hidden')
                $(this.$refs.brsModalButton).removeAttr('disabled')
                this.userHasBrs = true
                this.brsFileStatus = this.DOC_STATUSES['pending']
                this.brsUploading = false
                this.brsUploadSuccess = 'Les documents ont été envoyés avec succès'
                this.brsFiles = []
                NotificationsModule.ForceRefreshNotifications()
                this.sendAdminNotification(
                    'document',
                    `${this.userFullName} a déposé ses documents d'éligibilité BRS.`,
                    { user_id: this.userId, user_operation_id: this.userOperationId }
                )
            })
            .catch(() => {
                $(this.$refs.brsModalButton).children('i').addClass('hidden')
                $(this.$refs.brsModalButton).removeAttr('disabled')
                this.brsUploadError = "Les documents n'ont pas pu être envoyés."
                this.brsUploading = false
            })
    }

    // --- Lettre d'intention d'achat ---
    showPurchaseLetterModal() {
        const modal = $(this.$refs.purchaseLetterModal) as any
        modal.modal('show')
    }

    uploadPurchaseLetter() {
        if (this.purchaseLetterFile == null || this.purchaseLetterUploading) return

        $(this.$refs.purchaseLetterModalButton).children('i').removeClass('hidden').attr('disabled', 'true')
        this.purchaseLetterUploadError = null
        this.purchaseLetterUploadSuccess = null
        this.purchaseLetterUploading = true

        const fileReader = new FileReader()
        fileReader.readAsDataURL(this.purchaseLetterFile)
        fileReader.onload = () => {
            const dataURI = fileReader.result as string
            this.apiService.postPurchaseLetter(this.userId, { purchaseLetter: dataURI, user_operation_id: this.userOperationId })
                .then(() => {
                    $(this.$refs.purchaseLetterModalButton).children('i').addClass('hidden')
                    this.userHasPurchaseLetter = true
                    this.purchaseLetterStatus = this.DOC_STATUSES['pending']
                    this.purchaseLetterUploading = false
                    this.purchaseLetterUploadSuccess = 'Votre lettre d\'intention d\'achat a été envoyée avec succès. L\'équipe a été notifiée et procédera à sa vérification. Dès validation, vous passerez automatiquement à l\'étape suivante.'
                    NotificationsModule.ForceRefreshNotifications()
                    this.sendAdminNotification(
                        'purchase_letter',
                        `${this.userFullName} a envoyé sa lettre d'intention d'achat.`,
                        { user_id: this.userId, user_operation_id: this.userOperationId }
                    )
                })
                .catch(() => {
                    $(this.$refs.purchaseLetterModalButton).children('i').addClass('hidden')
                    this.purchaseLetterUploadError = "Le document n'a pas pu être envoyé."
                    this.purchaseLetterUploading = false
                })
        }
    }
}
